export default "__VITE_ASSET__DP2QIwJK__"